import React, { useCallback } from "react";
import { useHistory } from "react-router";

import { URL } from "../../constant";
import useAsideState from "../../hooks/useAsideState";

const MenuButton = ({
  iconPath = "/static/images/icon/ic_menu_32@2x.png",
  csName = "",
  csNote = "",
  noteIcon = "",
  isNote = false,
}) => {
  const history = useHistory();
  const { aSideState, setAsideState } = useAsideState();

  const onClickMenu = () => {
    setAsideState({ menu: !aSideState.menu });
  };

  const handlePage = useCallback((path) => {
    console.log("***** 메인페이지 -> 학습노트 페이지")
    history.push(path);
  }, [])

  return (
    <>
      {
        isNote && (
          <button
            type="button"
            className={`head_btn ${csNote}`}
            onClick={() => handlePage(URL.COURSE_LEARNING.LEARNING_NOTE)}
          >
            <img
              alt=""
              src={`${process.env.PUBLIC_URL}/${noteIcon}`}
            />
          </button>
        )
      }
      <button
        className={`head_btn ${csName}`}
        type="button"
        onClick={onClickMenu}
      >
        <img src={`${process.env.PUBLIC_URL}${iconPath}`} alt="" />
      </button>
    </>
  );
};

export default MenuButton;
